import color from "./color";
import effects from "./effects";
import font from "./font";
import spacing from "./spacing";
import state from "./state";

const semantic = {
    color,
    effects,
    font,
    spacing,
    state,
};

export { color, effects, font, spacing, state };
export default semantic;